export default __webpack_public_path__ + "static/media/desktop-background.c7196e64.webp";